import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * Wraps children and translates them on the Y axis as the element scrolls
 * through the viewport, creating a parallax depth effect.
 *  - speed: positive moves slower (drifts up), negative drifts down. ~-60..60 px range.
 */
export default function Parallax({ children, speed = 50, className, style }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [speed, -speed]);

  return (
    <motion.div ref={ref} className={className} style={{ y, ...style }}>
      {children}
    </motion.div>
  );
}
